var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.dark}},[_c('Toolbar'),(_vm.$vuetify.breakpoint.smAndDown || _vm.authenticated)?_c('NavigationDrawer'):_vm._e(),_c('v-content',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_vm._t("default",function(){return [_c('router-view',{key:_vm.$route.fullPath})]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }